"use client";

import { motion, useInView } from "framer-motion";
import { useRef, useState, useEffect } from "react";

/* =========================
   COUNTER (SMOOTH)
========================= */
const Counter = ({ value, duration = 1 }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  useEffect(() => {
    if (!isInView) return;

    let startTime = null;
    const end = parseInt(value);

    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;

      const t = Math.min(progress / (duration * 1000), 1);
      const eased = 1 - Math.pow(1 - t, 3);

      setCount(Math.floor(eased * end));

      if (t < 1) requestAnimationFrame(animate);
      else setCount(end);
    };

    requestAnimationFrame(animate);
  }, [isInView, value, duration]);

  return <span ref={ref}>{count}</span>;
};

/* =========================
   STATS SECTION (NEW UI)
========================= */
const Stats = ({ stats }) => {
  const data = stats || [
    { label: "Visa Approvals", value: "1500", suffix: "+", duration: 1.2 },
    { label: "Success Rate", value: "99", suffix: "%", duration: 0.8 },
    { label: "Markets Worldwide", value: "45", suffix: "+", duration: 1 },
    { label: "Professional Experts", value: "25", suffix: "+", duration: 1 },
  ];

  return (
    <section className="relative py-14 sm:py-20 bg-[#FAFAFA] overflow-hidden">

      {/* soft gold glow */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(184,137,58,0.08),transparent_60%)]" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">

          {data.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="relative text-center"
            >

              {/* number */}
              <h3 className="text-4xl sm:text-5xl lg:text-6xl font-black text-[#0A0A0A] tracking-tight">
                <Counter value={item.value} duration={item.duration} />
                <span className="text-[#B8893A]">{item.suffix}</span>
              </h3>

              {/* label */}
              <p className="mt-2 text-[11px] sm:text-xs uppercase tracking-[0.25em] font-semibold text-gray-500">
                {item.label}
              </p>

              {/* divider */}
              {i !== data.length - 1 && (
                <div className="hidden lg:block absolute right-[-20px] top-1/2 -translate-y-1/2 w-px h-12 bg-[#B8893A]/20" />
              )}

            </motion.div>
          ))}

        </div>
      </div>
    </section>
  );
};

export default Stats;
